import './App.scss';
import EditBetSlip from './pages/EditBetSlip';
import ConfirmBetSlip from './pages/ConfirmBetSlip';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import Home from './Home.js';
import localDao from './data/localDao';
import Game from './components/Game';
import Bingo from './components/bingo/Bingo';
import GameType from './data/GameType';
import Menu from './components/menu/Menu';

const sampleMenu = [

  {
    title: 'HasSubMenu',
    children: [
      {
        title: "Item2",
        location: '/bla2'
      },
      {
        title: "Item3",
        location: '/bla3'
      },
    ]
  },
  {
    title: "Item1",
    location: "/bla"
  },

];
const gameLoader = ({ params }) => {
  var result = localDao.getGameByName(params.game) || [];
  return result;
};
const bingoLoader = () => {
  var result = localDao.getGameByName(GameType.BINGO.name) ||[];
  return result;
};
//console.log(process.env.PUBLIC_URL);
const rootChildren = [
  {
    path: process.env.PUBLIC_URL,
    element: <EditBetSlip></EditBetSlip>
  },
  {
    path: process.env.PUBLIC_URL + '/menu',
    element: <Menu depth={0} items={sampleMenu}></Menu>,
    handle: { isMenu: true }
  },
  {
    path: process.env.PUBLIC_URL + '/game/:game',
    element: <Game isExpanded={true} isOpen={true}></Game>,
    loader: gameLoader,
  },
  {
    path: process.env.PUBLIC_URL + '/game/bingo',
    element: <Bingo isExpanded={true} isOpen={true}></Bingo>,
    loader: bingoLoader,
  },
  {
    path: process.env.PUBLIC_URL + '/editSlip',
    element: <EditBetSlip></EditBetSlip>
  },
  {
    path: process.env.PUBLIC_URL + '/finalslip',
    element: <ConfirmBetSlip></ConfirmBetSlip>,
  },
];
//console.log(rootChildren);
const router = createBrowserRouter([
  {
    element: <Home></Home>,
    children: rootChildren
  }

]);

function App() {
  return (
    <RouterProvider router={router} />
  );
}

export default App;
